const FAV_DATA = 'fav';

export const getFav = () => {
    const fav = window.localStorage.getItem(FAV_DATA);
    if (fav) {
        return JSON.parse(fav);
    }
    return [];
}

export const addToFav = (id) => {
    const json = getFav();
    json.push(id);
    window.localStorage.setItem(FAV_DATA, JSON.stringify(json));
}

export const removeFromFav = (id) => {
    const json = getFav();
    const index = json.indexOf(id);
    if (index >= 0) {
        json.splice(index, 1);
    }
    window.localStorage.setItem(FAV_DATA, JSON.stringify(json));
}

export const isInFav = (id) => {
    const json = getFav();
    const index = json.indexOf(id);
    return index >= 0;
}
